import { BioCodeData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export interface BioCodeFilterParams {
    name?: string;
    description?: string;
}

export class BioCodeList extends SimpleList<BioCodeData, BioCodeFilterParams> {
    protected readonly identifiableFieldName: string = 'name';

    protected filterValue(value: BioCodeData, filter: BioCodeFilterParams): boolean {
        return (
            this.filterFieldValueIncludesString(value, filter.name, 'name') &&
            this.filterFieldValueIncludesString(value, filter.description, 'description')
        );
    }
}
